export default {
    top_menu: [
        {name:'Home',    id:0},
        {name:'Show Business', id:1},
        {name:'Cocina',  id:2},
        {name:'Política',   id:3},
        {name:'Temas picantes',  id:4},
        {name:'Sociedad',   id:5},
        {name:'Salud',   id:6},
    ],
    read_other: 'Lee también',
    read_more:  'leer más',
    not_found:  'Nada encontrado',
    read_also:  'Lee también',
    copy_rights: 'Copyright © 2019 «mixer-novostei.ru». Todos los derechos reservados.',
    subscribe: 'Suscribete',


    thank_order: 'GRACIAS POR ORDEN',
    specialist_contact: 'Nuestro especialista se comunicará con usted pronto, espere nuestra llamada.',
    attention: 'Presta atencion',
    we_value_customers: 'Valoramos enormemente a cada uno de nuestros clientes, por lo que también ofrecemos nuestros productos especiales <b> con un precio especial solo para usted. </b>',
    hurry: '¡Date prisa, el tiempo de activación del descuento es limitado! Solo tiene <span id="time" class="time">30:00</span> minutos para elegir uno de estos productos únicos:',

    hour_ago1: "hace una hora",
    hour_ago2: "hace horas",
    hour_ago3: "hace horas",
    new_publications: "Publicaciones nuevas",
    read: "Leer",
    today_at: "Hoy a las",
    author_names: ['Elena Klimova','Mariia Andreeva','Irina Klimenko'],
    main_news: "Noticias principales",
    leave_already: "¿Ya se va? Espere, hemos actualizado las noticias para Ud.",
    already_shared: "ya compartido"
}